import OfficeBuilding from "@assets/images/office-building.svg";
import { Box, Grid } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { orderTypeChoices } from "@saleor/createOrderExport/components/AgencyTab/consts";
import { ContractExportOrderAllItemBySoNoQuery } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import SVG from "react-inlinesvg";
import { useIntl } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    root: {},
    header: {
      display: "flex",
      margin: "1.8rem 0",
      alignItems: "center",
      color: theme.palette.grey[900],
      fontSize: "1.8rem"
    },
    svg: {
      marginRight: "1.2rem"
    },
    box: {
      [theme.breakpoints.up("md")]: {
        maxWidth: "568px"
      },
      background: "#FFFFFF",
      padding: "2.4rem",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
      borderRadius: "12px"
    },
    selected: {},
    rightGrid: {
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      paddingRight: "2.4rem"
    },
    piNo: {
      background: theme.palette.background.default,
      borderRadius: "4px",
      padding: "0.9rem 0 0.9rem 1.6rem"
    }
  }),
  {
    name: "AgencyTabContent"
  }
);

export interface AgencyProps {
  dataExportOrder: ContractExportOrderAllItemBySoNoQuery["exportOrderWithAllItemsBySoNo"];
}

const AgencyTabContent: React.FC<AgencyProps> = ({ dataExportOrder }) => {
  const intl = useIntl();
  const classes = useStyles();

  // const getLabelDistributionChannel = () => {
  //   if (dataExportOrder?.pi?.distributionChannel?.id) {
  //     return `${dataExportOrder?.pi?.distributionChannel?.code} - ${dataExportOrder?.pi?.distributionChannel?.name}`;
  //   }
  //   return `${dataExportOrder?.distributionChannel?.code} - ${dataExportOrder?.distributionChannel?.name}`;
  // };

  // const getLabelSalesOrganization = () => {
  //   if (dataExportOrder?.pi?.salesOrganization?.id) {
  //     return `${dataExportOrder?.pi?.salesOrganization?.code} - ${dataExportOrder?.pi?.salesOrganization?.name}`;
  //   }
  //   return `${dataExportOrder?.salesOrganization?.code} - ${dataExportOrder?.salesOrganization?.name}`;
  // };

  // const getLabelDivision = () => {
  //   if (dataExportOrder?.pi?.division?.id) {
  //     return `${dataExportOrder?.pi?.division?.code} - ${dataExportOrder?.pi?.division?.name}`;
  //   }
  //   return `${dataExportOrder?.division?.code} - ${dataExportOrder?.division?.name}`;
  // };

  // const getLabelSaleOffice = () => {
  //   if (dataExportOrder?.pi?.salesOffice?.id) {
  //     return `${dataExportOrder?.pi?.salesOffice?.code} - ${dataExportOrder?.pi?.salesOffice?.name}`;
  //   }
  //   return `${dataExportOrder?.salesOffice?.code} - ${dataExportOrder?.salesOffice?.name}`;
  // };

  // const getLabelSaleGroup = () => {
  //   if (dataExportOrder?.pi?.salesGroup?.id) {
  //     return `${dataExportOrder?.pi?.salesGroup?.code} - ${dataExportOrder?.pi?.salesGroup?.name}`;
  //   }
  //   return `${dataExportOrder?.salesGroup?.code} - ${dataExportOrder?.salesGroup?.name}`;
  // };

  return (
    <div className={classes.root}>
      <MyTypography variant="body1" className={classes.header}>
        <SVG
          width={24}
          height={24}
          className={classes.svg}
          src={OfficeBuilding}
        />
        <b>{intl.formatMessage({ defaultMessage: "ข้อมูลหน่วยงาน" })}</b>
        &nbsp; ({intl.formatMessage({ defaultMessage: "ผู้สร้างคำสั่งซื้อ" })})
      </MyTypography>
      <form>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box className={classes.box}>
              <Grid container spacing={3}>
                <Grid item xs={5} className={classes.rightGrid}>
                  <MyTypography variant="body3">
                    {intl.formatMessage({
                      defaultMessage: "Contract / PI No."
                    })}
                  </MyTypography>
                </Grid>
                <Grid item xs={7}>
                  <MyTypography
                    variant="body3"
                    className={classes.piNo}
                    data-testid="contractNo"
                  >
                    {dataExportOrder?.contractNo}
                  </MyTypography>
                </Grid>
                <Grid item xs={5} className={classes.rightGrid}>
                  <MyTypography variant="body3">
                    {intl.formatMessage({
                      defaultMessage: "EO No."
                    })}
                  </MyTypography>
                </Grid>
                <Grid item xs={7}>
                  <MyTypography variant="body3" data-testid="eoNo">
                    {dataExportOrder?.eoNo}
                  </MyTypography>
                </Grid>
                <Grid item xs={5} className={classes.rightGrid}>
                  <MyTypography variant="body3">
                    {intl.formatMessage({ defaultMessage: "Order Type" })}
                  </MyTypography>
                </Grid>
                <Grid item xs={7}>
                  <MyTypography variant={"body3"} data-testid="orderType">
                    {
                      orderTypeChoices.find(
                        order => order.value === dataExportOrder?.orderType
                      )?.label
                    }
                  </MyTypography>
                </Grid>
                <Grid item xs={5} className={classes.rightGrid}>
                  <MyTypography variant="body3">
                    {intl.formatMessage({
                      defaultMessage: "Sales Organization"
                    })}
                  </MyTypography>
                </Grid>
                <Grid item xs={7}>
                  <MyTypography variant={"body3"} data-testid="salesOrg">
                    {dataExportOrder?.salesOrg}
                  </MyTypography>
                </Grid>
                <Grid item xs={5} className={classes.rightGrid}>
                  <MyTypography variant="body3">
                    {intl.formatMessage({
                      defaultMessage: "Distribution Channel"
                    })}
                  </MyTypography>
                </Grid>
                <Grid item xs={7}>
                  <MyTypography
                    variant={"body3"}
                    data-testid="distributionChannel"
                  >
                    {dataExportOrder?.distributionChannel}
                  </MyTypography>
                </Grid>
                <Grid item xs={5} className={classes.rightGrid}>
                  <MyTypography variant="body3">
                    {intl.formatMessage({ defaultMessage: "Division" })}
                  </MyTypography>
                </Grid>
                <Grid item xs={7}>
                  <MyTypography variant={"body3"} data-testid="division">
                    {dataExportOrder?.division}
                  </MyTypography>
                </Grid>
                <Grid item xs={5} className={classes.rightGrid}>
                  <MyTypography variant="body3">
                    {intl.formatMessage({ defaultMessage: "Sales Office" })}
                  </MyTypography>
                </Grid>
                <Grid item xs={7}>
                  <MyTypography variant={"body3"} data-testid="salesOff">
                    {dataExportOrder?.salesOff}
                  </MyTypography>
                </Grid>
                <Grid item xs={5} className={classes.rightGrid}>
                  <MyTypography variant="body3">
                    {intl.formatMessage({ defaultMessage: "Sales Group" })}
                  </MyTypography>
                </Grid>
                <Grid item xs={7}>
                  <MyTypography variant={"body3"} data-testid="salesGroup">
                    {dataExportOrder?.salesGroup}
                  </MyTypography>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};

export default AgencyTabContent;
